<template>
  <div style="background-color: #ebf0ff; height: 100%">
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center pt-5>
      <v-flex xs10 sm4 md4 text-left>
        <span style="font-family: sedanRegular; color: #000000; font-size: 20px">View Transaction</span>
      </v-flex>
      <v-flex xs10 sm4 md2 text-left pa-2>
        <span style="font-family: sedanRegular; font-size: 14px; color: #000">Transaction Type</span>
        <v-select lable="Transaction Type" outlined dense v-model="transactionType" :items="statusList" item-text="text"
          item-value="value">
        </v-select>
      </v-flex>
      <v-flex xs10 sm4 md2 text-left pa-2>
        <span style="font-family: sedanRegular; font-size: 14px; color: #000">Asset Type</span>
        <v-select lable="Asset Type" outlined dense v-model="assetType" :items="assetStatus" item-text="text"
          item-value="value">
        </v-select>
      </v-flex>
      <v-flex xs10 sm4 md2 text-left pa-2>
        <span style="font-family: sedanRegular; font-size: 14px; color: #000">User List</span>
        <v-autocomplete outlined dense :items="userList" v-model="user" item-text="name" item-value="_id"
          :search-input.sync="search">
        </v-autocomplete>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs10 pb-5>
        <v-data-table calculate-widths :headers="headers" @click:row="info" :items="assetList" hide-default-footer
          style="cursor: pointer;" class=" .text--black resize" id="virtual-scroll-table">
          <template v-slot:[`item.create_date`]="{ item }">
            <span v-if="item.create_date">{{ item.create_date.slice(0, 10) }}</span>
          </template>
          <template v-slot:[`item.Transfer`]="{ item }">
            <v-layout wrap>
              <v-flex xs12 v-if="item.transactionType == 'Transfer Units'">
                <span
                  v-if="item.transactionType == 'Transfer Units' && (item.transferType == 'Transfer to user' || item.transferType == 'Sale')">
                  S : {{ item.noOfUnits.toLocaleString() }} </span>
                <span
                  v-if="item.transactionType == 'Transfer Units' && (item.transferType == 'Transfer to platform' || item.transferType == 'Purchase')">
                  P : {{ item.noOfUnits.toLocaleString() }} </span>
              </v-flex>
              <v-flex xs12 v-else> <span>---</span></v-flex>
            </v-layout>

          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!-- <v-layout wrap justify-center pb-16 v-else>
      <v-flex xs12>
        <span style="font-family: sedanRegular; font-size: 20px; color: #000">No data found ...
        </span>
      </v-flex>
    </v-layout> -->
    <v-layout wrap justify-center>
      <v-flex xs12>
        <div class="text-center pb-5" v-if="pages > 1">
          <v-pagination :length="pages" :total-visible="7" v-model="currentPage" color="#6AAFEE"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    page: 1,
    currentPage: 1,
    pages: 0,
    limit: 10,
    appLoading: false,
    ServerError: false,
    showSnackBar: false,
    msg: null,
    timeout: 5000,
    userList: [],
    user: "",
    searchTerm: "",
    search: "",
    assetList: [],
    statusList: [
      { value: "", text: "All" },
      { value: "Register", text: "Register" },
      { value: "Update", text: "Update" },
      { value: "Transfer", text: "Transfer" },
      { value: "Transfer Units", text: "Transfer Units" },
    ],
    transactionType: "",
    assetStatus: [
      { value: "", text: "All" },
      { value: "Land", text: "Land" },
      { value: "Units", text: "Units" },
    ],
    headers: [
      { text: "Asset Name", value: "assetName", width: '180px' },
      { text: "Asset ID", value: "assetID", width: '80px' },
      { text: "Asset Type", value: "assetType", width: '100px' },
      { text: "Transaction Type", value: "transactionType", width: '150px' },
      { text: "Transfer", value: "Transfer", width: '100px' },
      { text: "Date", value: "create_date", width: '60px' },
    ],
    assetType: "",
  }),
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  watch: {
    transactionType() {
      this.getAsset();
    },
    assetType() {
      this.getAsset();
    },
    currentPage() {
      this.$store.commit("changeCurrentPage", this.currentPage);
      this.getAsset();
    },
    user() {
      this.getAsset();
    },
    search(key) {
      axios({
        method: "GET",
        url: "/users/list/v1",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          keyword: key,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.userList = response.data.data;
            this.userList.unshift(this.appUser)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    if (this.$store.state.currentPage) {
      this.currentPage = this.$store.state.currentPage;
      this.getAsset();
    } else this.getAsset();
    this.getUsers()
  },
  methods: {
    getAsset() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/assets/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          status: "Active",
          transactionType: this.transactionType,
          assetType: this.assetType,
          uid: this.user,
          limit: this.limit,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.assetList = response.data.data;
            this.pages = Math.ceil(response.data.totalLength / this.limit);
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUsers() {
      axios({
        method: "GET",
        url: "/users/list/v1",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.userList = response.data.data;
            this.userList.unshift(this.appUser)
            this.user = this.userList[0]._id
            // var temp = [
            //   {
            //     name: null,
            //     value: null,
            //   },
            // ];
            // temp = response.data.data;
            // for (var i = 0; i < temp.length; i++) {
            //   temp[i].name = temp[i].name;
            //   temp[i].value = temp[i]._id;
            // }
            // this.userList = temp;
            // this.userList.unshift({ name: "All", value: null });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();

      var strTime = day + " " + dt.slice(4, 7) + " " + year;

      return strTime;
    },
    info(id) {
      this.$router.push("/viewAsset?id=" + id._id)
    }
  },
};
</script>
<style>
.v-data-table-header {
  background-color: #c3e5ff;
  font-size: 20px;
  color: black;
}

.v-data-table .v-data-table-header tr th {
  font-size: 15px !important;
  color: black;
  font-family: montserratMedium;
}

.v-data-table tr td {
  font-size: 13px !important;
  color: black;
  font-family: montserratMedium;
}

.resize {

  min-width: 50px !important;
}

#virtual-scroll-table {
  max-width: 1200px;
  overflow: auto;
}
</style>